import React from "react";
import { Modal, Button } from "react-bootstrap";
import { apiDeleteLocalisation } from "../../../api/ApiLocalisation";
import { useTranslation } from "react-i18next";

const ModalDelete = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;

  const submitData = async () => {
    await apiDeleteLocalisation(id);
    handleRecupDatas();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminLocalisations.modalDeleteTitre")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {" "}
        {t("admin.PageAdminLocalisations.modalDeleteText")}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
